import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'

export const ListPayMethodItem = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  line-height: 25px;
  font-size: 18px;
  border-bottom: solid 1px #aaa;
  transition: background 200ms;
  align-items: center;

  ${p =>
    p.onClick &&
    `
    cursor: pointer;

    &:hover {
      background: rgba(100,197,175,0.25);
    }
  `}
`

export const Label = styled.span`
  color: ${color.GREY};
  font-size: 1.0625rem;
  margin-left: 0.9375rem;
  display: flex;
  align-items: center;
  align-content: flex-start;
  flex-grow: 1;
`

export const PaymentMethodDetailsContainer = styled.div`
size: w-full min-h-fit;
font: [&_p.strong]:sh-body [&_p.strong]:sh-strong [&_p.strong]:mb-0;
`

export const SmallSubtitle = styled.p`
  font-family: sidecarta-sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(117 117 117);
  margin-bottom: 0px;
`

export const Actions = styled.div`
  display: flex;
  width: 4.375rem;
  justify-content: flex-end;
`

export const Icon = styled(BaseIcon)`
  font-size: 1.5625rem;
  color: ${color.AQUAMARINE};
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 1.25rem;

  &:hover {
    color: ${color.SCOOTER};
  }
`
